import _ from "lodash";

import { Action } from "../../../actions/actions";
import { HallsActionTypes } from "../actions/actionTypes";

export function compareConfigurations(state: any[] = [], action: Action) {
    switch (action.type) {
        case HallsActionTypes.GET_COMPARE_CONFIGURATIONS_CLEAR:
            return [];
        case HallsActionTypes.GET_COMPARE_CONFIGURATIONS_SUCCESS:
            return action.payload.configurations;
        default:
            return state;
    }
}

export function compareConfigurationsLoading(
    state: boolean = true,
    action: Action
): boolean {
    switch (action.type) {
        case HallsActionTypes.GET_COMPARE_CONFIGURATIONS:
            return true;
        case HallsActionTypes.GET_COMPARE_CONFIGURATIONS_SUCCESS:
        case HallsActionTypes.GET_COMPARE_CONFIGURATIONS_FAIL:
        case HallsActionTypes.GET_COMPARE_CONFIGURATIONS_CLEAR:
            return false;
        default:
            return state;
    }
}
